import { render, staticRenderFns } from "./NewPartner.vue?vue&type=template&id=6e4e5260&"
import script from "./NewPartner.vue?vue&type=script&lang=js&"
export * from "./NewPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports